// extracted by mini-css-extract-plugin
export var menuItem = "T_wY d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "T_wZ d_Z d_bz d_bP";
export var menuMainLink = "T_w0 d_f0 d_dB";
export var menuLink = "T_w1 d_f0 d_dB";
export var icon = "T_n9 d_bC d_bP";
export var divider = "T_w2 d_bC d_bP";
export var sublinks = "T_w3";
export var link = "T_mC";
export var Link = "T_tk z_tk z_sx z_sS";